// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_image_tournament_form{
    display: grid;
    padding-bottom: var(--space-and-half);
}

.baloa-username.input_image_tournament_form_label{
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.baloa-username.input_file_tournament_label{
    font-weight: var(--font-medium);
    margin-left: var(--space-half);
    color: var(--basic-gray-color);
}

.input_image_tournament_form_text{
    color: var(--basic-gray-color);
    font-family: var(--secondary-font);
    line-height: calc( var(--space) + var(--space-quarter) );
    font-size: calc( var(--space) + 1px );
    letter-spacing: 0.0025em;
}

.upload_file__button {
    background: var(--white-color);
    color: var(--new-green-color);
    font-size: var(--space);
    padding: calc((var(--space-half))) calc((var(--space-and-half)));
    padding: 5px;
    border: 1px solid #CDCDCD;
    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);
    box-sizing: border-box;
    border-radius: 5.21739px;
}

.upload_file__button:disabled {
    color: var(--new-green-color);
}

.upload_file__button._active{
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.upload_file_icon{
    display: flex;
    justify-content: space-between;
    flex-direction: row;   
}

.upload_file_icon .hubicon-upload{
    margin-right: var(--space-quarter);
}

.input_image_tournament_form_input{
    display: flex;
    flex-direction: row;
    width: 50%;
    align-items: center;
    gap: var(--space);
    margin-top: 2px;
}

.baloa-username.input-fiel_message_error{
    color: var(--new-warning-color);
    margin-top: 10px;
}

.input_image_tournament_form_label_img{
    display: grid;
    align-items: center;
}

.input_image_tournament_form_label_img-delete_file {
    padding: 0px;
    margin-left: auto;
    min-width: var( --space-and-half );
    max-width: var( --space-and-half );
    height: var( --space-and-half );
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var( --new-gray-background-color );
    margin-left: auto;
    color: var( --primary-dark-color );
}

.input_image_tournament_form_label_img{
    display: flex;
}

button.button.text-button.invite_teams_league-addto__delete-button.baloa-hyperlink-2{
    padding-left: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/dynamic-fields-tournament-form/image-dynamic-form/ImageTournamentFormComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,wDAAwD;IACxD,qCAAqC;IACrC,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,gEAAgE;IAChE,YAAY;IACZ,yBAAyB;IACzB,8CAA8C;IAC9C,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kCAAkC;IAClC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oDAAoD;IACpD,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".input_image_tournament_form{\n    display: grid;\n    padding-bottom: var(--space-and-half);\n}\n\n.baloa-username.input_image_tournament_form_label{\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-username.input_file_tournament_label{\n    font-weight: var(--font-medium);\n    margin-left: var(--space-half);\n    color: var(--basic-gray-color);\n}\n\n.input_image_tournament_form_text{\n    color: var(--basic-gray-color);\n    font-family: var(--secondary-font);\n    line-height: calc( var(--space) + var(--space-quarter) );\n    font-size: calc( var(--space) + 1px );\n    letter-spacing: 0.0025em;\n}\n\n.upload_file__button {\n    background: var(--white-color);\n    color: var(--new-green-color);\n    font-size: var(--space);\n    padding: calc((var(--space-half))) calc((var(--space-and-half)));\n    padding: 5px;\n    border: 1px solid #CDCDCD;\n    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);\n    box-sizing: border-box;\n    border-radius: 5.21739px;\n}\n\n.upload_file__button:disabled {\n    color: var(--new-green-color);\n}\n\n.upload_file__button._active{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.upload_file_icon{\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;   \n}\n\n.upload_file_icon .hubicon-upload{\n    margin-right: var(--space-quarter);\n}\n\n.input_image_tournament_form_input{\n    display: flex;\n    flex-direction: row;\n    width: 50%;\n    align-items: center;\n    gap: var(--space);\n    margin-top: 2px;\n}\n\n.baloa-username.input-fiel_message_error{\n    color: var(--new-warning-color);\n    margin-top: 10px;\n}\n\n.input_image_tournament_form_label_img{\n    display: grid;\n    align-items: center;\n}\n\n.input_image_tournament_form_label_img-delete_file {\n    padding: 0px;\n    margin-left: auto;\n    min-width: var( --space-and-half );\n    max-width: var( --space-and-half );\n    height: var( --space-and-half );\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var( --new-gray-background-color );\n    margin-left: auto;\n    color: var( --primary-dark-color );\n}\n\n.input_image_tournament_form_label_img{\n    display: flex;\n}\n\nbutton.button.text-button.invite_teams_league-addto__delete-button.baloa-hyperlink-2{\n    padding-left: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
